import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flag-savings" }
const _hoisted_2 = { class: "flag-savings__first" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flag-savings__second" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", { innerHTML: _ctx.savedPercentage }, null, 8 /* PROPS */, _hoisted_3),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("span", {
        class: "flag-savings__first-text",
        innerHTML: _ctx.$t(_ctx.firstTextKey)
      }, null, 8 /* PROPS */, _hoisted_4)
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", { innerHTML: _ctx.savedAmount }, null, 8 /* PROPS */, _hoisted_6),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("span", {
        class: "flag-savings__second-text",
        innerHTML: _ctx.$t(_ctx.secondTextKey)
      }, null, 8 /* PROPS */, _hoisted_7)
    ])
  ]))
}